<template>
  <div class="animated fadeIn" id="editar-clientes">
    <div class="card card-default">
      <div class="card-header">
        <i class="icon-share"></i> Sincronização de Projetos
      </div>
      <div class="card-body">
        <h3 style="text-align: center; margin-bottom: 35px;"><i class="icon-share"></i> {{ formatarNome(cadastro.nome) }}</h3>

        <div class="row">
          <div class="form-group col-md-5 col-xs-12">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">Nome</span>
              </div>
              <input type="text" class="form-control" v-model="cadastro.nome" disabled>
            </div>
          </div>
          <div class="form-group col-md-4 col-xs-12">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">Centro de Custo</span>
              </div>
            
              <div class="col-md-7 no-label">
                <meta-select
                  id="input-centro-de-custo"
                  label="Centro de Custo"
                  name="centro-de-custo"
                  v-model="centroDeCusto"
                  attr-id="id"
                  attr-label="name"
                  :options="centrosDeCusto"
                  select-label="Selecionar"
                  deselect-label="Remover"
                  placeholder="Selecionar..."
                  ref="centroDeCusto">
                </meta-select>
              </div>
            </div>
          </div>
          <div class="form-group col-md-3 col-xs-12">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">Competência</span>
              </div>
              <input type="text" class="form-control" v-model="cadastro.competencia" disabled>
            </div>
          </div>
        </div>

        <button class="btn btn-primary pull-right" v-on:click="salvar"><i class="icon-check"></i> Salvar</button>
        <button class="btn btn-default pull-right" style="margin-right: 5px;" v-on:click="voltar"><i class="icon-action-undo"></i> Cancelar</button>
      </div>
    </div>

    <notifications group="editar-cliente" />
  </div>
</template>

<style lang="scss">
  // #editar-clientes {
    // Estilos
  // }
</style>

<script>
  import MetaSelect from 'meta-select'
  import Uteis from '@/mixins/utils.js';

  export default {
    mixins: [
      Uteis,
    ],

    components: {
      MetaSelect,
    },

    data() {
      return {
        namespace_id: null,
        centrosDeCusto: [],
        centroDeCusto: {},
        loadingProjeto: false,
        loadingCentrosDeCusto: false,
        cadastro: {
          id: null,
          nome: '',
          competencia: '',
          codigo_cc: '',
          responsavel: '',
        },
      };
    },

    mounted() {
      this.namespace_id = Number(this.$route.params.id);

      this.pesquisarProjeto();
      this.buscarCentrosDeCusto();
    },

    watch: {
      centroDeCusto() {
        if(typeof this.centroDeCusto != 'undefined' && typeof this.centroDeCusto.id != 'undefined') {
          this.cadastro.codigo_cc = this.centroDeCusto.id;
        } else {
          this.cadastro.codigo_cc = null;
        }
      },
      isLoading() {
        this.$events.$emit('loading', (this.loadingProjeto || this.loadingCentrosDeCusto));
      },
    },

    computed: {
      isLoading() {
        return this.loadingProjeto || this.loadingCentrosDeCusto;
      },
    },

    methods: {
      async salvar() {
        if (!this.cadastro.codigo_cc) {
          this.notificar('Preencha os campos obrigatórios', 'editar-cliente');
          return false;
        }

        try {
          this.$events.$emit('loading', true);

          await this.$http.post('/cliente-cc', this.getDTO());

          return this.notificar('Edição cadastrado com sucesso!', 'editar-cliente', 'success');
        } catch(e) {
          return this.notificar('Ocorreu um erro ao salvar o registro.', 'editar-cliente');
        } finally {
          await this.pesquisarProjeto();
          this.$events.$emit('loading', false);
        }
      },

      getDTO() {
        if (this.cadastro.id) {
          return {
            id: this.cadastro.id,
            centro_custo_sap: this.cadastro.codigo_cc,
          };
        }

        return {
          centro_custo_sap: this.cadastro.codigo_cc,
          namespace_id: this.namespace_id,
        };
      },

      async pesquisarProjeto() {
        try {
          this.loadingProjeto = true;
          const { data: cliente } = await this.$http.get(`/projeto/${this.namespace_id}`);

          this.carregarDados(cliente);
        } catch(e) {
          console.log(e);
          this.notificar('Ocorreu um erro ao carregar o Cliente.', 'editar-cliente');
        } finally {
          this.loadingProjeto = false;
        }
      },

      async buscarCentrosDeCusto() {
        try {
          this.loadingCentrosDeCusto = true;
          const { data: centrosDeCusto } = await this.$http.get(`/sap/centro-de-custo`);
          this.centrosDeCusto = centrosDeCusto.cc;

          let centroDeCusto = this.centrosDeCusto.filter((value) => {
            return value.id == this.cadastro.codigo_cc ? value : null;
          });
          
          this.centroDeCusto = centroDeCusto[0] || {};
        } catch (e) {
          console.log(e);
          this.notificar('Ocorreu um erro ao carregar os Centros de Custo.', 'editar-centro-de-custo');
        } finally {
          this.loadingCentrosDeCusto = false;
        }
      },

      carregarDados(cliente) {
        this.cadastro = {
          id: cliente.cc_id,
          nome: cliente.name,
          competencia: cliente.competencia,
          codigo_cc: cliente.centro_custo_sap,
          responsavel: cliente.responsavel_id,
        };
      },

      voltar() {
        this.$router.push({ path: '/projetos/sincronizar' });
      },
    },
  }
</script>

<style lang="css">
  .no-label .form-group {
    margin-bottom: 0px;
  }
  .no-label {
    padding: 0;
  }
  .no-label > div > div > .control-label {
    display: none !important;
  }
</style>
